import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'job_title', label: 'Job Title' },
  { key: 'department', label: 'Department' },
  { key: 'end_date', label: 'Contract End Date' },
  { key: 'days_remaining', label: 'Days Remaining', align: 'right' },
  { key: 'expiry_bucket', label: 'Status' },
];

export function ContractExpiryReport() {
  return (
    <ReportView
      title="Contract Expiry"
      description="Fixed-term contract employees whose current position has a recorded end date, soonest first."
      endpoint="/reports/hr/contract-expiry"
      columns={COLUMNS}
      xlsx
    />
  );
}
